export interface ForYouPoint {
  n: string;
  emoji: string;
  tag: string;
  title: string;
  text: string;
  bgClass: string;
  borderClass: string;
}

export const forYouPoints: ForYouPoint[] = [
  {
    n: '01',
    emoji: '😩',
    tag: 'Inseguridad',
    title: 'Llegas a la pista sin saber exactamente qué vas a entrenar.',
    text: 'Improvisas sobre la marcha en lugar de seguir una progresión pensada de antemano (técnica → táctica → competición). Y los jugadores lo notan.',
    bgClass: 'bg-naranja-pale',
    borderClass: 'border-naranja'
  },
  {
    n: '02',
    emoji: '📉',
    tag: 'Frustración',
    title: 'Tus jugadores no progresan de manera visible.',
    text: 'No tienes una secuencia clara de técnica individual (pase, lanzamiento, finta) y al final de la temporada no sabes si han mejorado realmente o simplemente han crecido.',
    bgClass: 'bg-azul-light',
    borderClass: 'border-azul'
  },
  {
    n: '03',
    emoji: '🔄',
    tag: 'Estancamiento',
    title: 'Siempre los mismos 8 o 10 ejercicios.',
    text: 'Repites lo mismo porque no tienes más material listo, y los jugadores llegan al entrenamiento sin ilusión. Los más avanzados se aburren. Los más atrasados se pierden.',
    bgClass: 'bg-naranja-pale',
    borderClass: 'border-naranja'
  },
  {
    n: '04',
    emoji: '👥',
    tag: 'Agobio',
    title: 'No sabes cómo gestionar a los padres sin que te quiten la energía.',
    text: 'Un padre que no entiende por qué su hijo no juega puede arruinar semanas de buen trabajo con el equipo.',
    bgClass: 'bg-azul-light',
    borderClass: 'border-azul'
  },
  {
    n: '05',
    emoji: '😨',
    tag: 'Miedo',
    title: 'Sientes inseguridad técnica cuando tienes que corregir.',
    text: 'Te cuesta saber exactamente qué decirle al jugador para que mejore su lanzamiento, su defensa en 6:0 o su desmarque.',
    bgClass: 'bg-naranja-pale',
    borderClass: 'border-naranja'
  },
  {
    n: '06',
    emoji: '💼',
    tag: 'Aspiración',
    title: 'Quieres que te reconozcan como un entrenador profesional.',
    text: 'Buscas ofrecer un sistema serio y estructurado, con una progresión clara detrás de cada sesión. Que el club, los padres y los jugadores te vean como un referente.',
    bgClass: 'bg-azul-light',
    borderClass: 'border-azul'
  }
];
